import { Airline, Domains, Languages } from "@/core/types/types";
import {
  fetchWithAbort,
  fetchWithTimeout,
  getLanguageByDomain,
  getTopLevelDomain,
  processApiResponse,
} from "@/core/utils";

const fetchOptions: object = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const getAirlineByIata = async (iata: string): Promise<Airline> => {
  const response: Response = await fetchWithTimeout(
    "api/getAirlineByIata?" + new URLSearchParams({ iata }),
    {
      ...fetchOptions,
      method: "GET",
    }
  );

  return processApiResponse(response);
};

export const getAirlines = async (
  airline: string = "",
  abortSignal: AbortSignal
): Promise<{
  airlines: Airline[];
  message?: string;
}> => {
  const domain: Domains = getTopLevelDomain() as Domains;
  const language: Languages = getLanguageByDomain(domain);

  const response: Response = await fetchWithAbort(
    "api/getAirlines?" + new URLSearchParams({ airline, language }),
    {
      ...fetchOptions,
      abortSignal,
      method: "GET",
    }
  );

  return processApiResponse(response);
};

export const validateAirlineByCode = async (
  airlineCode: string | undefined,
  returnCodeLength?: boolean
): Promise<{ isValid: boolean }> => {
  if (!airlineCode) {
    console.warn("Airline code should not be empty");
    return { isValid: false };
  }
  let url = `api/validateAirlineByCode/${airlineCode}`;

  if (returnCodeLength) {
    url += `?returnCodeLength=true`;
  }

  const response: Response = await fetchWithTimeout(url, {
    ...fetchOptions,
    method: "GET",
  });

  return processApiResponse(response);
};
